import { Form, Divider } from '@bancobarigui/barihaus';
import { Spin } from 'antd';

import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { UserInfoForm } from '@/components/UserInfoForm';
import { AddressFormItem } from '@/components/AddressForm';
import { SwitchCardItem } from '@/components/SwitchCardItem';
import { ProvidersTransfer } from '@/components/ProvidersTransfer';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';

import { useInspectorUserEdit } from './useInspectorUserEdit';

function InspectorUserEditContent() {
  const {
    form,
    loading,
    submitting,
    handleSubmit,
    handleCancel,
  } = useInspectorUserEdit();

  if (loading) {
    return (
      <div className="flex justify-center items-center" style={{ minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      className="space-y-4"
    >
      <UserInfoForm inspector={true} />

      <Divider>Endereço</Divider>

      <AddressFormItem form={form} />

      <Divider>Configurações</Divider>

      <div className="space-y-4">

        <SwitchCardItem
          name="allowsDemandReceiving"
          title="Permitir recebimento de demandas"
          text="Ao habilitar essa opção, o Inspetor ficará apto a receber novos direcionamentos"
        />
      </div>

      <Divider>Prestadora</Divider>

      <ProvidersTransfer />

      <Divider />

      <RegisterFormButtons
        onClickCancel={handleCancel}
        loading={submitting}
      />
    </Form>
  );
}

export function InspectorUserEdit() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Editar Inspetor" />}
    >
      <FeatureAlert services={['user']} />
      <ServiceCheck
        services={['user']}
        featureName="Edicao de Inspetor"
      >
        <InspectorUserEditContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
